import React from 'react'; 
import { useNavigate } from 'react-router-dom';
import stopImg1 from '../../../img/Stop1.jpeg'; // Primera imagen
import stopImg2 from '../../../img/Stop2.jpeg'; // Segunda imagen
import stopImg3 from '../../../img/Stop3.jpeg'; // Tercera imagen

const ProductsStops = () => {
  const navigate = useNavigate();

  const stopsProducts = [
    {
      stopNumber: "S001",
      description: "Stop duradero con un diseño elegante, ideal para espacios tanto modernos como tradicionales.",
      image: stopImg1 // Primera imagen
    },
    {
      stopNumber: "S002",
      description: "Stop de alta resistencia diseñado para máxima durabilidad y un rendimiento prolongado.",
      image: stopImg2 // Segunda imagen
    },
    {
      stopNumber: "S003",
      description: "Stop compacto y estilizado, perfecto para espacios pequeños o diseños minimalistas.",
      image: stopImg3 // Tercera imagen
    },
  ];

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8 font-montserrat">Colección de Stops</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stopsProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.stopNumber}
          >
            <img
              src={product.image}
              alt={`Stop ${product.stopNumber}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Stop {product.stopNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        {/* Tarjeta informativa */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">¿Necesitas más información?</h5>
            <p className="text-emerald-100 mb-4">
              ¿Te interesan nuestros stops? ¿Quieres discutir diseños personalizados o recibir una cotización? 
              Nuestro equipo está listo para ayudarte a encontrar el stop perfecto para tu proyecto.
            </p>
            <p className="text-emerald-100">
              Para ver la lista completa de productos, por favor regístrate para obtener tu token de acceso (clave).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contáctanos →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsStops;
